import type Transition from '@ember/routing/transition';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import ActionBookingsLogsController from 'uplisting-frontend/pods/action/bookings/logs/controller';

export default abstract class SidebarBookingsLogsRoute extends BaseRoute {
  abstract parentRoute: string;

  model() {
    return this.modelFor(this.parentRoute) as ModelRegistry['booking'];
  }

  setupController(
    controller: ActionBookingsLogsController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { booking: model });
  }
}
